/**
 * @param {ReduxState} state - The Redux state.
 * @param {string} year - The year you want the leaderboard for
 * @returns {object} The Draft Tracker Leaderboard data state.
 */
export const leaderboardDataSelector = (state, year) =>
    state.draftTracker.leaderboard?.data?.[year] || null;
